import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import { removeStoredValue, writeStoredJson } from '@/utils/storage';
import WarroomService from '@/services/WarroomService';
import PanelsService from '@/services/PanelsService';

const { UniversesService } = WarroomService;

export function getAccountUniverses({ state, commit }, { selectedAccount }) {
  commit(MUTATE, {
    property: 'requestStatus',
    with: 'loading',
  });

  const { id: accountId } = selectedAccount;

  return UniversesService.find({ url: `/${accountId}` })
    .then(data => {
      const { message = [] } = data;

      commit(MUTATE_MULTIPLE, [
        {
          property: 'requestStatus',
          with: 'success',
        }, {
          property: 'universes',
          with: message,
        },
      ]);
      if (message.length >= 1) {
        const matched = state.activeUniverse &&
          message.find(u => u.id === state.activeUniverse.id);
        commit(MUTATE_MULTIPLE, [{
          property: 'activeUniverse',
          with: matched || message[0],
        }]);
      }

      return Promise.resolve(message);
    }).catch((e) => {
      console.error(e);
      commit(MUTATE, {
        property: 'requestStatus',
        with: 'error',
      });
    });
}

export function getGroupsByUniverse({ state, commit }, universeId) {
  const activeUniverse = state.activeUniverse || {};
  const accountId = activeUniverse.account_id || activeUniverse.accountId;

  if (!accountId || !universeId) {
    return Promise.resolve([]);
  }

  return PanelsService.getGroupsByUniverse({ accountId, universeId })
    .then(groups => {
      if (groups.length) {
        commit(MUTATE, {
          property: 'groups',
          with: groups,
        });
      }
      return groups;
    }).catch(e => {
      console.error(e);
      return [];
    });
}

export function setUniverse({ commit }, { selectedUniverse }) {
  if (selectedUniverse) {
    writeStoredJson('admin_selectedUniverse', selectedUniverse);
  } else {
    removeStoredValue('admin_selectedUniverse');
  }
  commit(MUTATE, {
    property: 'activeUniverse',
    with: selectedUniverse,
  });
}

export function unsetUniverse({ commit }) {
  removeStoredValue('admin_selectedUniverse');
  commit(MUTATE, {
    property: 'activeUniverse',
    with: null,
  });
}
